import { render, staticRenderFns } from "./CsAsignacionesDetSolicitud.vue?vue&type=template&id=bffdbace"
import script from "./CsAsignacionesDetSolicitud.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesDetSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports